import cx from 'clsx'
import { PropsWithChildren } from 'react'

export function Container({ children }: PropsWithChildren) {
  return <div className={cx('faq-layout-container')}>{children}</div>
}
